﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const operational_context_client_1 = require("@its-suite/operational-context-client");
const OrganizationHelpers_1 = require("./OrganizationHelpers");
class OrganizationVisibilityHelpers {
    static isRoleVisible(role, organizationAppId) {
        return organizationAppId === '' || role.name !== operational_context_client_1.PermissionName.SuperAdmin.toString();
    }
    static isProfileVisible(profile, selectedOrganizationAppId, companyList) {
        let profileCompanyAppId = profile.company.appId;
        if (profileCompanyAppId === selectedOrganizationAppId) {
            return true;
        }
        let companyAppId = OrganizationHelpers_1.OrganizationHelpers.getCompanyAppIdOfOrganization(selectedOrganizationAppId, companyList);
        return companyAppId === profileCompanyAppId;
    }
}
exports.OrganizationVisibilityHelpers = OrganizationVisibilityHelpers;
//# sourceMappingURL=OrganizationVisibilityHelpers.js.map